/** Final progress percentage */
export const FINAL_PERCENT = 100;

/** Expected generation duration in seconds per media type */
export const GENERATION_DURATION_SECONDS: Record<string, number> = {
  image: 60,
  video: 300,
};

/** Rate limit cooldown in seconds before retry is allowed */
export const RATE_LIMIT_COOLDOWN_SECONDS = 30;
